// extracted by mini-css-extract-plugin
export var alertIcon = "_qd-0";